(function () {
  var d = document.documentElement;

  /* Mobile menu */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('site-nav');
  function setMenu(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { nav.className += ' is-open'; } else { nav.className = nav.className.replace(/\s*is-open/g, ''); }
  }
  if (toggle && nav) {
    toggle.addEventListener('click', function () { setMenu(toggle.getAttribute('aria-expanded') !== 'true'); });
    var links = nav.getElementsByTagName('a');
    for (var i = 0; i < links.length; i++) { links[i].addEventListener('click', function () { setMenu(false); }); }
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && toggle.getAttribute('aria-expanded') === 'true') { setMenu(false); toggle.focus(); }
    });
  }

  /* Reading settings (this browser only) */
  var state = { ts: 0, dys: false, hc: false };
  try {
    var saved = JSON.parse(window.localStorage.getItem('eai-reading') || '{}');
    if (saved.ts === 1 || saved.ts === 2) { state.ts = saved.ts; }
    state.dys = !!saved.dys; state.hc = !!saved.hc;
  } catch (e) {}
  var tsButtons = document.querySelectorAll('[data-ts]');
  var dysBtn = document.getElementById('dys-toggle');
  var hcBtn = document.getElementById('hc-toggle');
  function apply() {
    var c = d.className.replace(/\s*\b(ts-1|ts-2|dys|hc)\b/g, '');
    if (state.ts) { c += ' ts-' + state.ts; }
    if (state.dys) { c += ' dys'; }
    if (state.hc) { c += ' hc'; }
    d.className = c;
    for (var i = 0; i < tsButtons.length; i++) {
      tsButtons[i].setAttribute('aria-pressed', String(Number(tsButtons[i].getAttribute('data-ts')) === state.ts));
    }
    setSwitch(dysBtn, state.dys);
    setSwitch(hcBtn, state.hc);
    try { window.localStorage.setItem('eai-reading', JSON.stringify(state)); } catch (e) {}
  }
  function setSwitch(btn, on) {
    if (!btn) { return; }
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var s = btn.querySelector('.state');
    if (s) { s.textContent = on ? 'On' : 'Off'; }
  }
  for (var j = 0; j < tsButtons.length; j++) {
    tsButtons[j].addEventListener('click', function () { state.ts = Number(this.getAttribute('data-ts')); apply(); });
  }
  if (dysBtn) { dysBtn.addEventListener('click', function () { state.dys = !state.dys; apply(); }); }
  if (hcBtn) { hcBtn.addEventListener('click', function () { state.hc = !state.hc; apply(); }); }
  apply();

  /* Launch prices bar: the close button hides it and remembers that in this browser only. */
  var bar = document.getElementById('launch-bar');
  var barClose = bar ? bar.querySelector('.launch-bar__close') : null;
  if (barClose) {
    barClose.addEventListener('click', function () {
      bar.hidden = true;
      if (!/\blb-off\b/.test(d.className)) { d.className += ' lb-off'; }
      try { window.localStorage.setItem('eai-launch-bar', 'dismissed'); } catch (e) {}
      var next = document.querySelector('.site-header .brand');
      if (next) { next.focus(); }
    });
  }

  /* Four-Year AI Program buy buttons: on the Shopify store they point at the product page, so nothing to rewrite. */
})();
